var map = {
	"./clickhouse.svg": "a8b8",
	"./elasticsearch.svg": "b3d0",
	"./manticoresearch.svg": "718f",
	"./meilisearch.svg": "9cfb",
	"./mysql.svg": "86d1",
	"./mysql_percona.svg": "c3fe",
	"./postgres.svg": "9f09",
	"./quickwit.svg": "e152",
	"./typesense.svg": "cad4",
	"./zincsearch.svg": "2240"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f99c";